<template>
	<div class="settings-view">
		<div class="settings-view__login" v-if="!isLoggedIn">
			<BasicItem @click="() => openLogin()" class="settings-view__login-basic-item">
				<template #start>
					<FontAwesomeIcon :icon="faUser" />
				</template>
				<label>{{ $t('WEBAPP_LOGINS_USERACCOUNT') }}</label>
			</BasicItem>
		</div>

		<UserInfoView v-if="isLoggedIn" @close="$emit('close')" />
		<UserSettingsView @close="$emit('close')" />
	</div>
</template>

<script setup lang="ts">
import { AccountModal } from '@/lazy-load-components';
import BasicItem from '@/components/mobile/BasicItem.vue';
import UserInfoView from '@/components/user/UserInfoView.vue';
import UserSettingsView from '@/components/user/UserSettingsView.vue';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import { VFMHelper } from '@/helpers/vfm/vfm-helper';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/pinia/useUserStore';

defineEmits<{
	(e: 'close'): void;
}>();

const { isLoggedIn } = storeToRefs(useUserStore());

async function openLogin() {
	VFMHelper.closeById('settings');
	ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'account-modal' }, 'SettingsView');
}
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.settings-view {
	margin-top: 0;
	padding: 35px;

	@media (max-width: $screen-sm) {
		padding: 0;
	}

	&__login .freemium-subscription-banner {
		margin: 20px 30px;
	}

	&__login-basic-item.basic-item {
		--background: none;
		font-size: 20px;
		font-weight: bold;

		svg {
			color: $jw-color-mediumblue--light;
		}
	}
}
</style>
